export default __webpack_public_path__ + "static/media/plus.c6b5e8cb.svg";